import React from "react";
import * as FaIcons from "react-icons/fa";

import languageList from "../../../data/languageList";

const R8PrimaryLanguage = ({ formData, onFormDataChange, validationCheck }) => {
  const { firstName, primaryLanguage } = formData;
  return (
    <>
      {/* Primary Language */}
      <div className="sub-form">
        <h3>Primary Language</h3>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              What is {firstName === "" ? "the Student" : firstName}'s primary
              language?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="primaryLanguage"
            value={primaryLanguage}
            onChange={(e) => onFormDataChange(e)}
            style={{
              border:
                validationCheck && !(primaryLanguage !== "")
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <option value="">Please Select </option>
            {languageList.map((item) => {
              return <option value={item}>{item}</option>;
            })}
          </select>
        </div>
      </div>
    </>
  );
};

export default R8PrimaryLanguage;
